// extracted by mini-css-extract-plugin
export default {"desktopContent":"App_desktopContent__5JEQh","mobileContent":"App_mobileContent__7fcZo"};